import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { hexToRgba } from 'builder/styles/colors'

export const Illustration = styled.img`
  position: relative;
  z-index: 2;
  display: block;
  width: 100%;
`

export const Photo = styled.img`
  position: absolute;
  z-index: 3;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 2px solid ${Colors.Indigo50};
  background-color: ${Colors.White};
  box-shadow: 0 12px 16px ${hexToRgba(Colors.Indigo50, 0.24)};
`
